import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import './Password.css'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from './config'

const Password = () => {
  const history = useHistory()
  const timeoutRef = useRef(null)

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [isAffiliate, setIsAffiliate] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.title = "Forgot password - Can't log in"

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const clearError = () => {
    setErrorDisplay('none')
  }

  const showError = (message) => {
    setError(message)
    setErrorDisplay('block')

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  const handleForm = async () => {
    clearError()

    if (email.trim() === '') {
      showError('Enter your email address or phone number')
      return
    }

    setDisabled(true)
    setLoading(true)

    const baseURL = `${API_URL}/apps/kscanner/webservices.php`
    const data = new FormData()

    data.append('email', email.trim())
    data.append('isAffiliate', isAffiliate)
    data.append('query', 'RECOVERPASSWORD')

    try {
      const response = await Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })

      if (response.data.status === 'success') {
        history.push({
          pathname: '/set-password',
          state: {
            email: email.trim(),
            accounttype: response.data.account_type,
            message: response.data.message,
            isAffiliate: response.data.isAffiliate,
            account_name: response.data.account_name,
          },
        })

        return
      }

      showError(response.data.message || 'We could not find an account with those details.')
    } catch (err) {
      console.log(err)
      showError('Something went wrong. Please try again.')
    } finally {
      setDisabled(false)
      setLoading(false)
    }
  }

  return (
    <div className="kx-password-page">
      <div className="kx-password-bg">
        <div className="kx-password-bg__orb kx-password-bg__orb--one"></div>
        <div className="kx-password-bg__orb kx-password-bg__orb--two"></div>
        <div className="kx-password-bg__grid"></div>
        <div className="kx-password-bg__word">KARAMALE</div>
      </div>

      <main className="kx-password">
        <div className="kx-password__wrap">
          <section className="kx-password__brand">
            <Link to="/" className="kx-password__logo">
              karamale.
            </Link>

            <div className="kx-password__brand-content">
              <div className="kx-password__eyebrow">ACCOUNT RECOVERY</div>

              <h1>
                Forgot your
                <strong>password?</strong>
              </h1>

              <p>
                No problem. Enter the email address or phone number linked to your Karamale account
                and we'll help you get back in.
              </p>

              <div className="kx-password__features">
                <div className="kx-password__feature">
                  <span className="kx-password__feature-mark">01</span>
                  <span>Enter your account details</span>
                </div>

                <div className="kx-password__feature">
                  <span className="kx-password__feature-mark">02</span>
                  <span>Receive your verification code</span>
                </div>

                <div className="kx-password__feature">
                  <span className="kx-password__feature-mark">03</span>
                  <span>Create a new password</span>
                </div>
              </div>
            </div>

            <div className="kx-password__brand-footer">
              <span>Remember your password?</span>
              <Link to="/login">Log in</Link>
            </div>
          </section>

          <section className="kx-password__panel">
            <div className="kx-password__card">
              <div className="kx-password__card-head">
                <span className="kx-password__card-kicker">RESET PASSWORD</span>

                <h2>Let's get you back in.</h2>

                <p>Enter the email address or phone number associated with your account.</p>
              </div>

              <div className="kx-password__form">
                <div className="kx-password__field">
                  <label>Email or phone number</label>

                  <input
                    type="text"
                    name="email"
                    required
                    autoComplete="username"
                    placeholder="Email address or phone number"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value)
                      clearError()
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !disabled) {
                        handleForm()
                      }
                    }}
                  />
                </div>

                <label className="kx-password__affiliate">
                  <input
                    type="checkbox"
                    checked={isAffiliate}
                    onChange={(e) => {
                      setIsAffiliate(e.target.checked)
                      clearError()
                    }}
                  />

                  <span className="kx-password__affiliate-box"></span>

                  <span>I'm an affiliate</span>
                </label>

                <div className="kx-password__error" style={{ display: errorDisplay }}>
                  {error}
                </div>

                <button
                  type="button"
                  onClick={handleForm}
                  className="kx-password__submit"
                  disabled={disabled}
                >
                  {loading ? (
                    <ClipLoader color="#ffffff" loading={true} size={20} />
                  ) : (
                    <>
                      <span>Continue</span>
                      <span className="kx-password__submit-arrow">→</span>
                    </>
                  )}
                </button>

                <div className="kx-password__login">
                  <span>Remember your password?</span>
                  <Link to="/login">Log in →</Link>
                </div>

                <Link to="/" className="kx-password__back">
                  ← Back to Karamale
                </Link>
              </div>
            </div>

            <div className="kx-password__notice">
              If the email or phone is linked to an account, you'll receive an OTP shortly.
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}

export default Password
